module.exports = __webpack_public_path__ + "img/eatout-1.75e5df68.svg";